import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the projectDetailsPage state domain
 */

const selectProjectDetailsPageDomain = state => state.projectDetailsPage || initialState;

const makeSelectNetworkStatus = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.networkStatus);

const makeSelectPusherChannels = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.pusherChannels);

const makeSelectIsProfileCompleted = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.isProfileCompleted);

const makeSelectSlackChannels = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.slackChannels);

const makeSelectProfileDetails = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.profileDetails);

const makeSelectProfileLoading = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.isProfileLoading);

const makeSelectUserStatus = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.userStatus);

const makeSelectUserPermissions = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.profileDetails.permissions);

const makeSelectIsTimezoneListLoading = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.timezoneList.loading);

const makeSelectTimezoneList = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.timezoneList.data);

const makeSelectIsInitialApiCall = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.timezoneList.initialApiCall);

const makeSelectGifs = () =>
  createSelector(selectProjectDetailsPageDomain, subState => subState.gifs);

export {
  makeSelectNetworkStatus,
  makeSelectPusherChannels,
  makeSelectIsProfileCompleted,
  makeSelectSlackChannels,
  makeSelectProfileDetails,
  makeSelectUserStatus,
  makeSelectUserPermissions,
  makeSelectProfileLoading,
  makeSelectIsTimezoneListLoading,
  makeSelectTimezoneList,
  makeSelectIsInitialApiCall,
  makeSelectGifs,
};
